import React from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { Main, OTPEntry } from 'pages';
import { NewApplication } from 'pages/newApplication';
import { NotFound } from 'pages/Errors';
import { GlobalFonts } from 'layout/theme';

// Reset default browser margins/padding
const globalStyles = `
  * {
    box-sizing: border-box;
  }
  html, body {
    margin: 0;
    padding: 0;
  }
  #root {
    margin: 0;
    padding: 0;
  }
  /* #261: no overflow:hidden / fixed height here, so pages taller than the viewport
     (phone + on-screen keyboard) can scroll. newApplication owns its own 100dvh layout. */
  .app-root {
    min-height: 100vh;
    min-height: 100dvh;
  }
`;

const App = () => (
    <>
        <style>{globalStyles}</style>
        <div
            dir="rtl"
            className="app-root"
            style={{
                fontFamily: 'Kan-Regular, Arial, sans-serif',
                width: '100%',
                margin: 0,
                padding: 0,
            }}
        >
            <GlobalFonts />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Main />} />
                    <Route path="/new-application/:id/otp" element={<OTPEntry />} />
                    <Route path="/new-application/:id" element={<NewApplication />} />
                    <Route path="/not-found" element={<NotFound />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
        </div>
    </>
);

export default App;
